/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTheme, useMediaQuery, Breakpoint } from '@mui/material';

export const useUpMedia = (bp: Breakpoint | number) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up(bp));
};
